var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plot-card"},[_c('div',{staticClass:"title-wrapper"},[_c('cms-text',{staticClass:"plod-card-title",attrs:{"value":`${_vm.prefix}.cards.${_vm.index}.title`,"props":{tag: 'h4', color: 'white', weight: 'bold'}}})],1),_c('cms-image',{staticClass:"plot-card-image",attrs:{"src":{
			path: _vm.plot.image.path,
			alt: `${_vm.plot.title} of ${_vm.productName}`,
			title: `${_vm.plot.title} of ${_vm.productName}`
		},"base":{width: 1020, height: 388, fit: 'contain', background: 'transparent'},"lazy":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }